import './GridFilter.scss';

import React, { Component } from 'react';
import classnames from 'classnames';
import { isNil } from 'lodash';

import LabeledSelect from 'components/shared/SelectOption/LabeledSelect';

export default class GridFilter extends Component {
  constructor(props) {
    super(props);

    this.valueGetter = this.props.valueGetter;
  }

  onChange = ({ target }) => {
    const newValue = target.value;
    const { change } = this.props;

    change(newValue);
  };

  render() {
    const { disabled, className, label, options, selection } = this.props;

    const filterClassName = classnames({
      [className]: !isNil(className),
      disabled: disabled
    });

    return (
      <div className={filterClassName}>
        <LabeledSelect
          label={label}
          options={options}
          selection={selection}
          onChange={this.onChange}
          disabled={disabled}
        />
      </div>
    );
  }
}
